import { printHeader } from "branch/functions/pirntHeader";
import { printTopRight } from "branch/functions/pirntTopRight";
import { alertError } from "components/Alert";
import jsPDF from "jspdf";
import { printFinanceReportColumns } from "./printFinanceReportColumns";
import { printTableWrapText } from "utils/printTableWrapText";
import dayjs from "dayjs";
import { numberFormat } from "utils";


/**
 * mode = 'BUY' | 'SELL'
 */
export const printFinanceReport = ({ msData, dataTable, mode }) => {

  if (dataTable.length === 0) {
    alertError("กรุณาเลือกข้อมูลก่อนพิมพ์รายงาน")
    return
  }

  dataTable.forEach(row => {
    row.E1Diff = row.IsSub === 1 ? +(row.IncE1 || 0) - +(row.ScE1 || 0) : +(row.IncE1 || 0) - +(row.ItmSumCostAmnt || 0)
  })
  const pageSize = [8.3, 11.7];
  const doc = new jsPDF({
    orientation: "landscape",
    unit: "in",
    format: pageSize
  })



  const startY = 0.3
  const startX = 0.3
  const lineHeight = 0.20
  const contentSize = 12;
  const MAX_ROW = 25;
  let yPos = startY
  let xPos = startX

  doc.setLineWidth(0.01)
  doc.setFont("THSarabun")

  const numPage = Math.ceil(dataTable.length / MAX_ROW)

  const docNo = (mode === 'BUY' ? dataTable[0].PVNo : dataTable[0].RVNo) || "-"
  const docDte = (mode === 'BUY' ? dataTable[0].PVDte : dataTable[0].RVDte) || "-"
  const docDteStr = dayjs(docDte).isValid() ? dayjs(docDte).format("DD/MM/YYYY") : "-"

  const modDataTable = []
  let sumAdv = 0
  let sumSub = 0
  let sumInc = 0
  let sumScWhtPr = 0
  let sumIncWhtPr = 0
  for (const row of dataTable) {
    const newRow = {
      ...row,
      id: row.JobOrdId,
      DocDte: mode === 'SELL' ? row.InvDte : row.ScInvDte,
      DocNo: mode === 'SELL' ? row.InvNo : row.ScInvNo,
    }
    modDataTable.push(newRow)
    sumAdv += +(row.IncCusRcptTotal || 0)
    sumSub += +(row.ScOwnRcptTotal || 0)
    sumInc += +(row.IncOwnRcptTotal || 0)
    sumScWhtPr += +(row.ScWhtPr || 0)
    sumIncWhtPr += +(row.IncWhtPr || 0)
  }
  modDataTable.push({
    id: 0,
    JobNo: "รวมทั้งสิ้น",
    IncCusRcptTotal: sumAdv,
    ScOwnRcptTotal: sumSub,
    IncOwnRcptTotal: sumInc,
    // DocDte: "ส่วนต่าง",
    E1Diff: sumInc - sumSub,
  })
  for (let i = 0; i < numPage; i++) {
    if (i > 0) {
      doc.addPage(pageSize)
    }
    yPos = startY
    xPos = startX

    const titleObj = {
      xPos: 9,
      label: `${mode === "SELL" ? "รายงานการขาย" : "รายงานการซื้อ"} `,
    }
    const infoObj = {
      xPos: 8.1,
      objs: [
        {
          header: "Document NO. : ",
          value: docNo,
          headerWidth: 1.2
        },
        {
          header: "Document Date : ",
          value: docDteStr,
          headerWidth: 1.2
        },
      ]
    }
    yPos = printTopRight({ jsPDFDoc: doc, titleObj, infoObj, startY: startY + 0.2 })
    doc.text(`${numPage > 1 ? `(หน้า ${i + 1}/${numPage})` : ""}`, 9, yPos, { align: "center" })

    yPos = printHeader({ jsPDFDoc: doc, companyData: msData.serverData.CompanyData, startX: xPos, startY: startY })
    yPos += lineHeight

    const printDataTable = modDataTable.slice(i * MAX_ROW, (i + 1) * MAX_ROW);

    yPos = printTableWrapText({
      doc,
      dataTable: printDataTable,
      columns: printFinanceReportColumns,
      startX: startX,
      startY: yPos,
      fontSize: contentSize
    })
  }
  const colScOwnRctpTotal = printFinanceReportColumns.find(col => col.field === 'ScOwnRcptTotal')
  const colIncOwnRctpTotal = printFinanceReportColumns.find(col => col.field === 'IncOwnRcptTotal')
  const colIncCusRcptTotal = printFinanceReportColumns.find(col => col.field === 'IncCusRcptTotal')
  const incCusRctpTotalIndex = printFinanceReportColumns.findIndex(col => col.field === 'IncCusRcptTotal')
  let colIncCusRctpTotalXPos = startX
  for (let i = 0; i < incCusRctpTotalIndex; i++) {
    colIncCusRctpTotalXPos += printFinanceReportColumns[i].printWidth || 0.5
  }
  const colScOwnRcptTotalXPos = colIncCusRctpTotalXPos + colIncCusRcptTotal.printWidth || 0.5
  const colIncOwnRcptTotalXPos = colScOwnRcptTotalXPos + colScOwnRctpTotal.printWidth || 0.5
  yPos += lineHeight

  doc.setFont("THSarabun", "bold")
  doc.text("หัก ณ ที่จ่าย 1%", colIncCusRctpTotalXPos + colIncCusRcptTotal.printWidth || 0.5, yPos, { align: "right" })
  doc.text(numberFormat(sumScWhtPr), colScOwnRcptTotalXPos + (colScOwnRctpTotal.printWidth || 0.5) - 0.05, yPos, { align: "right" })
  doc.text(numberFormat(sumIncWhtPr), colIncOwnRcptTotalXPos + (colIncOwnRctpTotal.printWidth || 0.5) - 0.05, yPos, { align: "right" })

  yPos += lineHeight
  doc.text("ยอดจ่าย", colIncCusRctpTotalXPos + colIncCusRcptTotal.printWidth || 0.5, yPos, { align: "right" })
  doc.text(numberFormat(sumSub - sumScWhtPr), colScOwnRcptTotalXPos + (colScOwnRctpTotal.printWidth || 0.5) - 0.05, yPos, { align: "right" })
  doc.text(numberFormat(sumInc - sumIncWhtPr), colIncOwnRcptTotalXPos + (colIncOwnRctpTotal.printWidth || 0.5) - 0.05, yPos, { align: "right" })
  doc.line(colScOwnRcptTotalXPos, yPos + 0.05, colIncOwnRcptTotalXPos + (colIncOwnRctpTotal.printWidth || 0.5), yPos + 0.05)
  doc.line(colScOwnRcptTotalXPos, yPos + 0.08, colIncOwnRcptTotalXPos + (colIncOwnRctpTotal.printWidth || 0.5), yPos + 0.08)
  const blob = new Blob([doc.output('blob')], { type: 'application/pdf' });
  const blobUrl = URL.createObjectURL(blob);
  
  // Open in new tab
  window.open(blobUrl, '_blank');
  
  // Clean up memory after a small delay
  
;
}